import $ from 'jquery';
import ScrollMagic from 'ScrollMagic';
import {Power1, Power0, Power4, TimelineMax} from "gsap/TweenMax";
import 'TextPlugin';
import 'CSSRulePlugin';
import 'CSSPlugin';
import 'animation.gsap';
import 'debug.addIndicators';


export default () => {

    function geLineBg(value) {
        // console.log(value);
        const pathLineLight = '/wp-content/themes/g2k-theme/resources/assets/images/linee_riquadro_colorato/linea_bianca_intera_dettaglio.png';
        const pathLineDark = '/wp-content/themes/g2k-theme/resources/assets/images/linee_riquadro_colorato/linea_nera_intera_dettaglio.png';
        if (value == 'grappa-bio' ||
            value == 'grappa-estrema-50' ||
            value == 'grappa-gentile' ||
            value == 'grappa-botti-di-sherry' ||
            value == 'grappa-pinot-nero' ||
            value == 'grappa-botti-di-whisky') {
            return pathLineLight;
        }
        return pathLineDark;
    }


    if ($(window).width() > 768 && $('body').attr('class').indexOf('single-prodotto') === -1) {

        // Esci se non c'è componente in pagina
        let products = $('.bottles-component').data("products");
        if (products !== undefined && products.length > 0) {
            let bottlesContainerSelector = ".bottle-item";

            if ($(bottlesContainerSelector).length <= 0) return;

            let controller = new ScrollMagic.Controller();
            let tlBottle = new TimelineMax();


            $('.col-right').css('background-image', 'url(' + geLineBg(products[0].type) + ')');

            let ruleBtnBefore = CSSRulePlugin.getRule(".bottle-item_link:before");
            let ruleBtn = CSSRulePlugin.getRule(".bottle-item_link");

            for (var i = 1; i < products.length; i++) {
                let element = products[i];
                let count = '' + (i + 1);

                tlBottle
                    /*.add("fadeout")
                    .to($('.bottle-item_name'), 0.5, {delay: 1, autoAlpha: 0, ease: Power0.easeNone}, 'fadeout')
                    .to($('.bottle-item_descrizione'), 0.5, {delay: 1, autoAlpha: 0, ease: Power0.easeNone}, 'fadeout')
                    .to($('.bottle-item_claim'), 0.5, {delay: 1, autoAlpha: 0, ease: Power0.easeNone}, 'fadeout')
                    .to($('.bottle-item_link'), 0.5, {delay: 1, autoAlpha: 0, ease: Power0.easeNone}, 'fadeout')
                    .to($('.bottle-item_immagine img'), 1, {delay: 1, x: '+=100', autoAlpha: 0, ease: Power0.easeNone}, 'fadeout')
*/
                    //sostituzione elementi
                    .set($('.bottle-item_name'), {text: element.name})
                    .set($('.bottle-item_descrizione p'), {text: element.descrizione})
                    .set($('.bottle-item_claim p'), {text: element.claim})
                    .set($('.bottle-item_link'), {href: element.link})
                    .set($('.bottle-item_immagine img'), {src: element.immagine})
                    .to($('.col-right'), 0.5, {backgroundColor: element.colore})
                    .to($('.col-right'), 0.5, {backgroundImage: 'url(' + geLineBg(element.type) + ')'})
                    .set($('.bottle-item_count h4 span.number'), {text: count}, '+=0.5')
                    .to(ruleBtnBefore, 0.5, {cssRule: {background: "linear-gradient(to right, #464646 50%, " + element.colore + " 50%)"}})
                    .to(ruleBtn, 0.5, {cssRule: {background: "linear-gradient(to right, #464646 50%, " + element.colore + " 50%)"}})

                    .add("fadein")
                    .fromTo($('.bottle-item_name'), 1, {y: '+=20'}, {y: 0, autoAlpha: 1, ease: Power4.easeOut, immediateRender: false}, 'fadein')
                    .fromTo($('.bottle-item_descrizione'), 1, {y: '+=20'}, {y: 0, autoAlpha: 1, ease: Power4.easeOut, immediateRender: false}, 'fadein')
                    .fromTo($('.bottle-item_claim'), 1, {y: '+=20'}, {y: 0, autoAlpha: 1, ease: Power4.easeOut, immediateRender: false}, 'fadein')
                    .fromTo($('.bottle-item_link'), 1, {y: '+=20'}, {y: 0, autoAlpha: 1, ease: Power4.easeOut, immediateRender: false}, 'fadein')
                    .fromTo($('.bottle-item_immagine img'), 1, {x: '+=100'}, {x: '0', autoAlpha: 1, ease: Power4.easeOut, immediateRender: false}, 'fadein')

                    .add("fadein2")
                    .to($('.bottle-item_name'), 1, {autoAlpha: 1, ease: Power4.easeOut, immediateRender: false}, 'fadein2')
                    .to($('.bottle-item_descrizione'), 1, {autoAlpha: 1, ease: Power4.easeOut, immediateRender: false}, 'fadein2')
                    .to($('.bottle-item_claim'), 1, {autoAlpha: 1, ease: Power4.easeOut, immediateRender: false}, 'fadein2')
                    .to($('.bottle-item_link'), 1, {autoAlpha: 1, ease: Power4.easeOut, immediateRender: false}, 'fadein2')
                    .to($('.bottle-item_immagine'), 1, {autoAlpha: 1, ease: Power4.easeOut, immediateRender: false}, 'fadein2');


            }


            let bottleScene = new ScrollMagic.Scene({
                triggerElement: bottlesContainerSelector,
                duration: (products.length * 100) + "%",
                triggerHook: 0
            })
                .setPin(bottlesContainerSelector)
                .addIndicators({name: "Bottle trigger"})
                .setTween(tlBottle)
                .addTo(controller);

        }

    }
}



// WEBPACK FOOTER //
// ./scripts/libs/bottle_component.js